import http from "@utils/request";

/**
 * 获取用汽申报列表
 * @param {*} start_time 
 * @param {*} end_time 
 * @param {*} site_list 
 * @param {*} page 
 * @param {*} size 
 * @returns 
 */
export const getGasList = (start_time,end_time,site_list,page=0,size=10) => http({
    method: "POST",
    url: "/phemsjava/getGasList",
    data: {
        start_time,end_time,site_list,page,size
    },
});

/**
 * 更新数据
 * @param {*} gas 
 * @returns 
 */
 export const updateGas= (gas) => http({
    method: "POST",
    url: "/phemsjava/updateGas",
    contentType:"json",
    data: gas,
});